module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Apple-Watch-cdf4f1ca92601f77eab71dbc3657f01e.svg";